import { LogLevel, PublicClientApplication } from "@azure/msal-browser";
import { APP_BASE_URL } from "./constants";

// const isTeamsDesktop = () => {
//   return window.parent !== window && 
//          window.navigator.userAgent.includes('Teams/');
// };


const getRedirectUri = () => {
  return `${APP_BASE_URL}/auth`; // For web
};

 const msalConfig = {
  auth: {
    clientId: "2d4b2d47-2011-4b9e-b789-dbacff73382e",
    authority: "https://login.microsoftonline.com/common",
    redirectUri: getRedirectUri(),
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: "sessionStorage", // Use sessionStorage for better security
    storeAuthStateInCookie: true,
  },
   system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (level > LogLevel.Info) { // Only show warnings and errors
            console.log("MSAL:", message);
          }
        },
        piiLoggingEnabled: false,
        logLevel: LogLevel.Warning // Change from Verbose to Warning
      },
    allowNativeBroker: false, // Disable for Teams tabs
    windowHashTimeout: 10000, // Increase timeout for macOS
    iframeHashTimeout: 10000,
    loadFrameTimeout: 10000
   }
};

export const msalInstance = new PublicClientApplication(msalConfig);
